import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController
  @values: {timeout: Number, sortablePath: String, togglePath: String}
  @targets: ['hSortable', 'vSortable', 'alert', 'warning', 'notice', 'banner', 'announcement', \
             'sidebar', 'breadcrumbs', 'menuItem', 'manual']

  # Move sections
  initialize: ->
    @setSessionExpiration() if @hasTimeoutValue
    $(@hSortableTargets).sortable(
      axis: 'x', tolerance: 'pointer',items: '> *',
      handle: '> :first-child > .handle, > nav.menu:nth-child(2) > .handle, > aside:nth-child(2) > .handle',
      update: (event, ui) =>
        @removePosition(ui.item)
        @adjustSidebarPosition(ui.item)
        @sendOrder(event.target, 'id', '(.*)'))
    $(@vSortableTargets).sortable(
      axis: 'y', tolerance: 'pointer', items: '> :not(h2, #login_modal)', handle: '> .handle',
      cancel: ':first-child > .handle, nav.menu:nth-child(2) > .handle, aside:nth-child(2) > .handle',
      update: (event, ui) =>
        @removePosition(ui.item)
        @sendOrder(event.target, 'class', '([^ ]+) .*'))

  # Display messages on load
  connect: ->
    @highlightCurrent() if @hasBreadcrumbsTarget
    $(@bannerTarget).click()
    $(@announcementTarget).slideDown(1000) if @hasAnnouncementTarget
    @addHeadings()
    @setAuthenticityToken()
    @updateAnchor() if location.pathname is '/manual'

  # Set session expiration
  setSessionExpiration: ->
    setInterval (-> $.get '/active', (data) -> window.location = '/timeout' if data is 'false'),
                (@timeoutValue || 60) * 1000

  # Highlight current menu item
  highlightCurrent: ->
    breadcrumbs = $(@breadcrumbsTarget).find('ul li').map(() -> $(@).text())
    page = if breadcrumbs[0] in ['Index', 'Design Manual'] then breadcrumbs[breadcrumbs.length - 1] \
           else breadcrumbs[2] or breadcrumbs[0]
    @menuItemTargets.forEach (target) ->
      $(target).addClass('current') if page is $(target).find('span').text().trim()

  # Show messages
  showMessages: (event) ->
    if $(@noticeTarget).find('div').text().trim().length then $(@alertTarget).before($(@noticeTarget))
    # else if $(@warningTarget).find('div').text().trim().length then $(@alertTarget).before($(@warningTarget))
    unless $(@noticeTarget).find('div').text().trim().length then $(@noticeTarget).before($(@warningTarget))
    $(@alertTarget).slideDown(500, => setTimeout (=> $(@alertTarget).click()), 20000) \
      if $(@alertTarget).find('div').text().trim().length
    $(@warningTarget).slideDown(500, => setTimeout (=> $(@warningTarget).click()), 20000) \
      if $(@warningTarget).find('div').text().trim().length
    $(@noticeTarget).slideDown(500, => setTimeout (=> $(@noticeTarget).click()), 20000) \
      if $(@noticeTarget).find('div').text().trim().length
    event.stopPropagation()

  # Hide one message
  hideMessage: -> $(@alertTarget).slideUp 500; $(@warningTarget).slideUp 500; $(@noticeTarget).slideUp 500

  # Close design & help pages
  close: -> window.close()

  # Toggle sidebar
  toggleSidebar: (event) ->
    visible = $(@sidebarTarget).is(':visible')
    permanent = $(@sidebarTarget).css('position') isnt 'absolute'
    $(@sidebarTarget).toggle 'slide', {direction: if $(@sidebarTarget).next().length then 'left' else 'right'}, 200
    if permanent
      headers = 'Content-Type': 'application/x-www-form-urlencoded', \
                'X-CSRF-Token': $('meta[name=csrf-token]').prop('content')
      fetch @togglePathValue,
            method: 'PATCH', credentials: 'include', headers: headers, body: $.param {visible : not visible}
    event.stopPropagation()

  # Hide sidebar on window click for small screens
  hideSidebar: (event) ->
    if @hasSidebarTarget
      visible = $(@sidebarTarget).is(':visible')
      permanent = $(@sidebarTarget).css('position') isnt 'absolute'
      $(@sidebarTarget).hide 'slide', {direction: if $(@sidebarTarget).next().length then 'left' else 'right'}, 200 \
        if not permanent and visible

  # Send order command
  sendOrder: (target, attribute, expression) ->
    headers = 'Content-Type': 'application/x-www-form-urlencoded', \
              'X-CSRF-Token': $('meta[name=csrf-token]').prop('content')
    fetch @sortablePathValue,
          method: 'PATCH', credentials: 'include', headers: headers,
          body: $(target).sortable('serialize', key: "#{target.id}[]", attribute: attribute, expression: expression)

  # Adjust sidebar position on reordering
  adjustSidebarPosition: (item) ->
    if item.css('position') is 'absolute'
      item.filter('aside:first-child').css({left: '0px', right: 'unset'})
      item.filter('aside:last-child').css({left: 'unset', right: '0px'})
      item.prev('aside:first-child').css({left: '0px', right: 'unset'})
      item.next('aside:last-child').css({left: 'unset', right: '0px'})

  # Remove position from moved item
  removePosition: (item) -> item.attr('style', '')

  # Add hidden headings for accessibility
  addHeadings: ->
    $('main').each (_, item) => @findOrCreateHeading item, 'h1'
    $('aside[id], footer[id], nav[id]').each (_, item) => @findOrCreateHeading item, 'h2'
    $('main > section[id], main > form > section[id], main > :not(section) > :not(.panels) section[id], \
       .panels > section[id], .dash_view > section.panel').
      each (_, item) => @findOrCreateHeading item, 'h2'
    $('main > section > section[id], .panels > * section[id], .panel_view > section section[id]').
      each (_, item) => @findOrCreateHeading item, 'h3'
    $('main section.run > section.item').each (_, item) => @findOrCreateHeading item, 'h3,h4,h5'

  findOrCreateHeading: (item, tag) ->
    heading_id = $(item).prop('id') + '_heading'
    unless $(item).children(tag).length
      new_tag = tag.split(',')[0]
      $(item).prepend $("<#{new_tag}>").addClass('visually_hidden').text($(item).prop('id').titleize())
    $(item).children(tag).attr('id', heading_id)
    $(item).attr('aria-labelledby', heading_id) #unless item.tagName is 'ASIDE'

  # Set correct authenticity token for cached forms
  setAuthenticityToken: ->
    $(@element).find('input[name=authenticity_token]').val($('meta[name=csrf-token]').attr('content'))

  # Set window title & position for manual anchors
  updateAnchor: ->
    if search = $(window.location).prop('search').split('=')[1]
      $(@manualTarget).scrollTop 0
      $(@manualTarget).scrollTop $("##{search}").offset().top - $(@manualTarget).offset().top

  # set full screen for phones
  # $ ->
  #   toggleFullScreen = ->
  #     if (!document.fullscreenElement) then document.documentElement.requestFullscreen()
  #     else if (document.exitFullscreen) then document.exitFullscreen()
  #   toggleFullScreen() if navigator.platform == 'Android'
  #   $('body').css('height', $(window).height() + 50) if navigator.platform == 'Android'

  # screen resolution test code
  # $ -> alert("screenWidth = #{$(window).width()}, windowWidth = #{$(document).width()},
  #   screenHeight = #{$(window).height()}, windowHeight = #{$(document).height()}")

  # show spinner on remote commands
  # $(document).on("ajax:beforeSend", "form[data-remote]", (event) ->
  #    /* spinner show logic */
